<template>
  <section class="settings">
    <div class="settings__content">
      <div class="settings__group">
        <h2>{{ getTranslations.home_settings_game_settings }}</h2>
        <div class="settings__group__content">
          <ul>
            <li v-if="!hideLangSelection && showLang()">
              <div class="settings-left"><h3>{{ getTranslations.home_settings_language }}</h3></div>
              <div class="settings-right lang">
                <ul>
                  <li v-for="(value, key, index) in localesMappedWithIndices" :key="index" style="cursor:pointer">
                    <a @click="updateAndStoreNewLanguageAndLocale(key, value[0])" :class="settingsPageLocales[value[0]] !== undefined && settingsPageLocales[value[0]].isActive ? 'active' : ''">{{ value[1] }}</a></li>
                </ul>
              </div>
            </li>
            <li>
              <div class="settings-left"><h3>{{ getTranslations.home_settings_sound_music }}</h3></div>
              <div class="settings-right">
                <div class="onoffswitch">
                  <input id="sounds" type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" @change="updateSoundsStatus" :checked="checked">
                  <label class="onoffswitch-label" for="sounds"><span></span></label>
                </div>
              </div>
            </li>
            <!--<li>-->
            <!--<div class="settings-left"><h3>{{ getTranslations.home_settings_tutorial_mode) }}</h3></div>-->
            <!--<div class="settings-right">-->
            <!--<div class="onoffswitch">-->
            <!--<input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="tutorial">-->
            <!--<label class="onoffswitch-label" for="tutorial"><span></span></label>-->
            <!--</div>-->
            <!--</div>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
      <div class="settings__group">
        <h2>{{ getTranslations.home_settings_account_settings }}</h2>
        <div class="settings__group__content">
          <ul>
            <li @click="goToEditProfile" style="cursor:pointer">
              <a>
                <div class="settings-left"><h3>{{ getTranslations.home_settings_edit_my_profile }}</h3></div>
                <div class="settings-right icon"><i class="icon-arrow-right"></i></div>
              </a>
            </li>
            <li @click="userChangeStatus" style="cursor:pointer" v-if="showStatus()">
              <a class="settings-left"><h3>{{ userStatus }}</h3></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="settings__group">
        <h2>{{ getTranslations.home_settings_others }}</h2>
        <div class="settings__group__content">
          <ul>
            <li @click="goToHowItWorks" style="cursor:pointer">
              <a>
                <div class="settings-left"><h3>{{ getTranslations.home_settings_how_it_works }}</h3></div>
                <div class="settings-right icon"><i class="icon-arrow-right"></i></div>
              </a>
            </li>
            <li v-if="showTerms()">
              <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
                 target="_blank">
                <div class="settings-left"><h3>{{ getTranslations.home_settings_terms_and_conditions }}</h3></div>
                <div class="settings-right icon"><i class="icon-arrow-right"></i></div>
              </a>
            </li>
            <li v-if="showTerms()">
              <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">
                <div class="settings-left"><h3>{{ getTranslations.visitor_visitor_privacy_policy }}</h3></div>
                <div class="settings-right icon"><i class="icon-arrow-right"></i></div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- dynamically change modals -->
    <component :is="modalForSettings"></component>
  </section>

</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../common/modals';
import Unsubscribe from './modals/Unsubscribe';
import UnsubscribeSms from './modals/UnsubscribeSms';
import ResubscribeRequestSettings from './modals/ResubscribeRequestSettings';
import ResubscribeQuestionViaSms from './modals/ResubscribeQuestionViaSms';

export default {
  name: 'settings',
  mixins: [IntegrationMixin],
  data() {
    return {
      userStatus: null,
      checked: true,
    };
  },
  created() {
    this.getUserStatusForSettingsMethod();
    this.$nextTick(() => {
      this.checked = this.soundsOn;
    });
  },
  updated() {
    this.getUserStatusForSettingsMethod();
  },
  methods: {
    ...mapMutations('common', [
      'setSoundsOnOrOff',
      'storeModalForSettings',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'updateActiveLocale',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
    ]),
    ...mapActions('i18n', [
      'getLocaleAndTranslations',
      'updateUserLanguage',
    ]),
    showStatus() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || activeIntegration.value.enabledStatusInSettingsPage;
    },
    showTerms() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.hideTerms;
    },
    showLang() {
      const activeIntegration = this.getIntegrationByName();
      return !activeIntegration || !activeIntegration.value.hideLangSelectionLoginArea;
    },
    updateAndStoreNewLanguageAndLocale(locale, localeIndex) {
      this.updateActiveLocale(localeIndex);
      localStorage.setItem('locale', locale);
      this.setLocale({ currentLocale: locale });
      this.updateUserLanguage().then(() => {
        this.getLocaleAndTranslations().then(() => {
          this.storeAvailablePrizeTypes(this.getLocale);
          this.storeVisitorWinners(this.getLocale);
        });
      });
    },
    goToHowItWorks() {
      this.$router.push('/home/howitworksLoggedIn');
    },
    goToEditProfile() {
      this.$router.push('profile/edit');
    },
    userChangeStatus() {
      // user is subscribed
      if (this.userDetails.subscribed) {
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'OPTOUT_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(UnsubscribeSms);
          } else {
            this.storeModalForSettings(Unsubscribe);
          }
        } else {
          this.storeModalForSettings(Unsubscribe);
        }
        modals.showHideModal(this);
      } else {
        // user is unsubscribed
        // eslint-disable-next-line
        if (this.subAndUnsubViaSMS) {
          if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
            this.storeModalForSettings(ResubscribeQuestionViaSms);
          } else {
            this.storeModalForSettings(ResubscribeRequestSettings);
          }
        } else {
          this.storeModalForSettings(ResubscribeRequestSettings);
        }
        modals.showHideModalForHomePage(this);
      }
    },
    getUserStatusForSettingsMethod() {
      if (!this.userDetails.subscribed) {
        this.userStatus = this.getTranslations.home_settings_resubscribe;
      } else {
        this.userStatus = this.getTranslations.home_settings_unsubscribe;
      }
    },
    updateSoundsStatus() {
      this.checked = !this.checked;
      this.setSoundsOnOrOff(this.checked);
      localStorage.setItem('soundsOn', this.checked);
    },
  },
  computed: {
    ...mapState('common', [
      'hideLangSelection',
      'soundsOn',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'modalForSettings',
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapState('i18n', [
      'settingsPageLocales',
      'localesMappedWithIndices',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Settings.vue